import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Choose Your Model',
  description: 'Select from our library of FPGA-optimized models or upload your own ONNX/PyTorch files.'
}, {
  number: '02',
  title: 'Pick Your FPGA',
  description: 'Route your workload to the best hardware for your specific latency and throughput needs.'
}, {
  number: '03',
  title: 'Deploy & Scale',
  description: 'One API call to deploy. We handle the bitstream loading, scaling, and hardware management.'
}];
export function HowItWorks() {
  return <div className="py-24 bg-gate-dark relative overflow-hidden" data-id="element-154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-157">
            How OpenFPGA Works
          </h2>
          <p className="text-gate-text-secondary max-w-2xl mx-auto" data-id="element-158">
            From model to hardware inference in three simple steps.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-159">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-gate-border to-transparent border-t-2 border-dashed border-gate-border/30 z-0" data-id="element-160" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-161">
              <div className="w-24 h-24 rounded-full bg-gate-dark border-4 border-gate-surface flex items-center justify-center mb-6 shadow-xl relative group" data-id="element-162">
                <div className="absolute inset-0 rounded-full border-2 border-gate-teal/20 group-hover:border-gate-teal transition-colors duration-300" data-id="element-163" />
                <span className="text-3xl font-mono font-bold text-gate-teal" data-id="element-164">
                  {step.number}
                </span>
              </div>

              <h3 className="text-xl font-bold text-white mb-3" data-id="element-165">
                {step.title}
              </h3>
              <p className="text-gate-text-secondary leading-relaxed max-w-xs" data-id="element-166">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}